<template>
  <!-- Start Header Area -->
  <header class="header navbar-area">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-12">
          <div class="nav-inner">
            <nav class="navbar navbar-expand-lg">
              <router-link to='/'>
                <img
                  src="https://spng.subpng.com/20190911/aeg/transparent-purple-circle-violet-logo-symbol-5d789e6522bd59.0239713915681859571423.jpg"
                  alt="Logo"
                  style="max-width: 30%; height: auto"
                />
              </router-link>

              <div
                class="navbar-collapse sub-menu-bar"
                id="navbarSupportedContent"
              >
                <ul id="nav" class="navbar-nav">
                  <li class="nav-item">
                    <router-link to="/"
                      ><span class="active" aria-label="Toggle navigation"
                        >Home</span
                      ></router-link
                    >
                  </li>
                  <li class="nav-item" v-if='this.$store.state.isLoggedIn == true'>
                    <router-link to="/favorites"
                      ><span class="active" aria-label="Toggle navigation"
                        >Favorites</span
                      ></router-link
                    >
                  </li>
                </ul>
              </div>
              <!-- navbar collapse -->
              <div class="login-button">
                <ul>
                  <li v-if='this.$store.state.isLoggedIn == false'>
                    <router-link to="/login"
                      ><span class="active" aria-label="Toggle navigation"
                        ><i class="lni lni-enter"></i> Login</span
                      ></router-link
                    >
                  </li>
                  <li v-if='this.$store.state.isLoggedIn == false'>
                    <router-link to="/register"
                      ><span class="active" aria-label="Toggle navigation"
                        ><i class="lni lni-user"></i> Register</span
                      ></router-link
                    >
                  </li>
                </ul>
              </div>
              <div class="button header-button" v-if='this.$store.state.isLoggedIn == true'>
                <button @click="logOut" class="btn">Log Out</button>
              </div>
            </nav>
            <!-- navbar -->
          </div>
        </div>
      </div>
      <!-- row -->
    </div>
    <!-- container -->
  </header>
  <!-- End Header Area -->
</template>

<script>
export default {
  name: "NavBar",
  methods: {
    logOut(){
      let payload = {status :false}
      this.$store.commit("SET_LOGIN_STATUS",payload)
      localStorage.clear();
      this.$router.push("/").catch(()=>{})
      this.$swal.fire({
        position: "top-end",
        icon: "success",
        title: "You have been logged out",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }
};
</script>

<style>
</style>